import { render, staticRenderFns } from "./manageAccessUser.vue?vue&type=template&id=55654ff7&scoped=true&"
import script from "./manageAccessUser.vue?vue&type=script&lang=js&"
export * from "./manageAccessUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55654ff7",
  null
  
)

export default component.exports